
export { CallCampaignPhoneAndScheduleWithIcon } from "/home/runner/work/apollo/apollo/packages/shells/shared/src/presentation/molecules/call-campaign/call-campaign-phone-and-schedule-with-icon.tsx"